import { useParams, Link } from "react-router-dom";
import { Wrench, ArrowLeft } from "lucide-react";
import { PageHeader } from "./shared";

const titleFromSlug = (slug) =>
  (slug || "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

export default function ModulePlaceholder() {
  const { slug } = useParams();
  const title = titleFromSlug(slug);
  return (
    <div className="min-h-screen">
      <PageHeader title={title} subtitle="Module" />
      <div className="p-8">
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-[#12142b]/15 bg-white p-16 text-center shadow-sm">
          <span className="grid h-14 w-14 place-items-center rounded-2xl bg-[#2340b5]/8">
            <Wrench className="h-7 w-7 text-[#2340b5]" strokeWidth={1.75} />
          </span>
          <h2 className="mt-6 font-display text-xl font-bold text-[#12142b]">{title} is coming soon</h2>
          <p className="mt-2 max-w-md text-sm text-[#565b73]">
            This module is scaffolded and ready to be built out. User Management, Payments & Finance,
            and Customer Support are fully functional today.
          </p>
          <Link to="/admin" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[#2340b5] px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#1b3390]">
            <ArrowLeft className="h-4 w-4" /> Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
